module.exports = __webpack_public_path__ + "static/img/GettyImages-588551173.f37d644.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/GettyImages-588551173.jpg
// module id = W6cx
// module chunks = 0